export const en = {
    add: 'Add',
    edit: 'Edit',
    'upload-error': 'Invalid file type, please use JPEG or PNG formats',
    'upload-source': 'Upload from computer'
};
